import React, { useRef } from 'react';
//components
import toast from 'components/Toast/dispatch';
import Button from '../../../../../../Button';
//interfaces
import { IMinPriceModal } from './interface';
//services
import QuoteServices from '../../../../../../../../../../services/quote.service';
//utils
import { currencyOutputNumber } from 'utils/CurrencyOutput';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
import { useExceptionPriceBelowMinContext } from 'contexts/ExceptionPriceBelowMin';
//styles
import './styles.scss';

const MinPriceModal = ({
  open,
  setOpen,
  unitPrice,
  customerCode,
  setOpenTooltip,
  sequenceNumber,
  distributionCenter,
  setUpdatedMinPrice,
  setUnitPriceMessage,
  supplierProductcode,
}: IMinPriceModal) => {

  const modal: any = useRef(null);

  const { quoteItem, setQuoteItem } = useDetailsQuoteContext();
  const { exceptionPriceBelowMin, updateExceptionPriceBelowMinState } = useExceptionPriceBelowMinContext();
  const reasons = ['Acordo/OL não cadastrado', 'Preço simulador', 'Aprovado pela Supervisão/Gestão', 'Preço praticado pelo pricing'];

  function handleChangeReason(event: any) {
    updateExceptionPriceBelowMinState(false, event.target.value);
  };

  const closeOpen = (e: any) => {
    if (modal?.current && open && !modal?.current.contains(e.target)) {
      handleOpenClose();
    }
  };

  const handleOpenClose = () => {
    if (open === false) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleButtonGetItemStock = async () => {
    const unitPriceFixedValue = parseFloat(unitPrice).toFixed(2);

    const resultMapping = await new QuoteServices().getItemStock(
      supplierProductcode,
      customerCode,
    );
    if (resultMapping) {
      resultMapping.map((item: any, index: any) => {
        const quoteItemUpdated = { ...quoteItem! };
        const indexUpdate = quoteItemUpdated.data?.findIndex((x: any) => x.sequenceNumber === sequenceNumber);
        const items = quoteItemUpdated.data && { ...quoteItemUpdated.data[indexUpdate!] };
        quoteItemUpdated.data?.splice(indexUpdate!, 1);

        items?.productsSuggestion![0]?.itemStock?.map((stock: any) => {
          resultMapping.map((res: any) => {
            if (stock.local === res.local) {
              stock.minimumPrice = res.minimumPrice;
            }
          });
        });

        quoteItemUpdated?.data?.splice(indexUpdate!, 0, items!);

        setQuoteItem(quoteItemUpdated);
        if (item.local === distributionCenter)
          setUnitPriceMessage(`Aplicar valor mínimo ${currencyOutputNumber(item.minimumPriceLock1)}`);
        if (unitPriceFixedValue >= item.minimumPriceLock1) {
          setOpenTooltip({ ...{ unitPrice: false } });
          setUpdatedMinPrice(item.minimumPriceLock1);
        }
        setOpen(false);
      });

    } else {
      toast.error(
        "Não foi possível atualizar preço mínimo. Por favor, tente novamente."
      );
    };
  };

  const handleModalClose = () => {
    document.addEventListener("mousedown", closeOpen);
  };
  handleModalClose();

  const submitReason = () => {
    if (!exceptionPriceBelowMin.reason) return;

    updateExceptionPriceBelowMinState(true, exceptionPriceBelowMin.reason);
    setOpen(false);
    return;
  };

  const cancelReason = () => {
    updateExceptionPriceBelowMinState(false);
    setOpen(false);
  };

  return (
    <>
      <div className='modalContainer' ref={modal}>
        <div className='blockedPrice'>
          <div className='modalTitle'>Preço Mínimo Bloqueado</div>
        </div>
        <div>
          <p className='modalText'>Para aplicar valores abaixo do preço mínimo,<br />escolha o motivo na lista abaixo.</p>
          <span className='modalTextSecondary'><strong>Atenção</strong>: A trava de preço continua habilitada no Money.<br />Para liberação, é necessário aprovação da supervisão para<br />que o novo preço seja utilizado na criação de Pedidos.</span>
        </div>

        <form className='inputRadioContainer'>
          {reasons.map(reason => (
            <label key={reason} className='labelRadio'>
              <input
                className='inputRadio'
                type="radio"
                name={reason}
                value={reason}
                checked={exceptionPriceBelowMin.reason === reason}
                onChange={handleChangeReason} />
              {reason}
            </label>
          ))}
        </form>
        <div className='applyPriceContainer'>
          <button onClick={() => cancelReason()} className='cancelPriceButton'>Cancelar</button>
          <button disabled={!exceptionPriceBelowMin.reason} onClick={() => submitReason()} className='applyPriceButton'>Aplicar</button>
        </div>
      </div>
    </>
  );
};
export default MinPriceModal;